/**
 * Single method for converting date to string
 * - Forces .toISOString()
 */
export function dateToString(date: Date | string | number): string {
    return new Date(date).toISOString();
}
